import { render } from "./Structure.vue?vue&type=template&id=75dcb986&scoped=true"
import script from "./Structure.vue?vue&type=script&lang=js"
export * from "./Structure.vue?vue&type=script&lang=js"

import "./Structure.vue?vue&type=style&index=0&id=75dcb986&lang=scss"
import "./Structure.vue?vue&type=style&index=1&id=75dcb986&lang=scss&scoped=true"

import exportComponent from "/Users/mymac/Documents/Digitala/Perki/newest-perki/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75dcb986"]])

export default __exports__